<app-navbar></app-navbar>
<div class="w-100">
    <div class="m-auto panel_container">
        <router-outlet></router-outlet>
    </div>
</div>
<app-footer></app-footer>